import React, { useEffect, useState } from 'react';
import Form from 'antd-mobile/es/components/form';
import Input from 'antd-mobile/es/components/input';
import Toast from 'antd-mobile/es/components/toast';
import classNames from 'classnames';
import { Button } from '../H5Button/button';
import styles from './index.module.scss';
import { ItemPopup } from '../H5FormItem/ItemPopup';
import { createBrandItem } from '../../apis';
import { useTranslation, useLanType } from '../../LangContext';
import { MTDIcon } from '../../../../components/Icon';
import PopupTitle from '../PopupTitle';

interface Props {
  onClose(): void;
}
export const H5Form = (props: Props) => {
  const [form] = Form.useForm();
  const { onClose } = props;

  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);
  const [brandPopupVisible, setBrandPopupVisible] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [brandName, setBrandName] = useState('');

  const lanType = useLanType();
  const brandQueryConfig = {
    queryApi: 'queryBrandList',
    queryParams: { lanType },
    dependencies: [lanType],
    keywordsKey: 'brand',
  };
  const companyQueryConfig = {
    queryApi: 'queryCompanyList',
    queryParams: { lanType, brand: brandName },
    dependencies: [lanType, brandName],
    keywordsKey: 'company',
  };
  const brandItemConfig = {
    queryFunc: brandQueryConfig,
    placeholder: 'formConfig.brandPlaceholder',
    title: 'formConfig.brandTitle',
    fetchingTips: 'fetchingTips',
    notFoundContent: 'notFound.content',
  };

  const companyItemConfig = {
    queryFunc: companyQueryConfig,
    placeholder: 'formConfig.contactCompanyPlaceholder',
    title: 'formConfig.contactCompanyTitle',
    fetchingTips: 'contactCompanyFetchingTips',
    notFoundContent: 'contactCompanyNotFound.content',
  };

  // 是否展示额外的输入框
  const onValuesChange = (_: Record<string, any>, allValues: Record<string, any>) => {
    const changed = allValues.brandName;
    if (brandName !== changed) {
      setBrandName(changed);
      form.setFieldValue('contactCompany', '');
    }
    if (changed) {
      setVisible(true);
    } else {
      setVisible(false);
    }
    setSubmitDisabled(
      !(allValues.contactCompany && allValues.brandName && allValues.contactName && allValues.contactPhone),
    );
  };

  const onSubmit = () => {
    form.validateFields().then((formValues) => {
      setVisible(false);
      createBrandItem({ ...formValues, businessType: 'LAO_ZI_HAO' })
        .then(() => {
          Toast.show({
            content: <div style={{ textAlign: 'center' }}>{t('successTips')}</div>,
          });
        })
        .catch(() => {
          Toast.show({
            content: <div style={{ textAlign: 'center' }}>{t('failTips')}</div>,
          });
        })
        .finally(() => {
          onClose();
          form.setFieldsValue({ contactCompany: '', brandName: '', contactName: '', contactPhone: '' });
          setVisible(false);
        });
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setBrandPopupVisible(true);
      clearTimeout(timer);
    }, 200);
  }, []);

  return (
    <div className={styles.formContainer}>
      <PopupTitle onClose={onClose} title={t('applyTitle')} />
      <div className={styles.formContainerInner}>
        <div>
          <div className={styles.alert}>
            <MTDIcon className={styles.alertIcon} icon="mtdicon-info-circle" />
            {t('applyTooltips')}
          </div>
          <Form
            form={form}
            onValuesChange={onValuesChange}
            initialValues={{ brandName: '', contactCompany: '', contactName: '', contactPhone: '' }}
          >
            <Form.Item
              name="brandName"
              label={t('formConfig.brandLabel')}
              rules={[{ required: true, message: t('formConfig.brandErrorTips') }]}
            >
              {brandPopupVisible && <ItemPopup key="brandPopup" ItemConfig={brandItemConfig} />}
            </Form.Item>
            {visible && (
              <>
                <Form.Item
                  name="contactCompany"
                  label={t('formConfig.contactCompany')}
                  rules={[
                    {
                      required: true,
                      message: t('formConfig.brandErrorTips'),
                    },
                  ]}
                >
                  <ItemPopup key="companyPopup" ItemConfig={companyItemConfig} />
                </Form.Item>
                <Form.Item
                  name="contactName"
                  label={t('formConfig.contactNameLabel')}
                  rules={[
                    {
                      required: true,
                      message: t('formConfig.contactNameErrorTips'),
                    },
                    {
                      max: 20,
                      message: t('formConfig.contactNameErrorTips'),
                    },
                    {
                      min: 1,
                      message: t('formConfig.contactNameErrorTips'),
                    },
                  ]}
                >
                  <Input placeholder={t('formConfig.contactNamePlaceholder')} />
                </Form.Item>
                <Form.Item
                  name="contactPhone"
                  label={t('formConfig.contactPhoneLabel')}
                  rules={[
                    {
                      required: true,
                      message: t('formConfig.contactPhoneErrorTips'),
                    },
                    {
                      pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                      message: t('formConfig.contactPhoneErrorTips'),
                    },
                  ]}
                >
                  <Input placeholder={t('formConfig.contactPhonePlaceholder')} maxLength={11} />
                </Form.Item>
              </>
            )}
          </Form>
        </div>

        <div className={styles.footer}>
          <div className={classNames(styles.footerItem, styles.cancelBtn)}>
            <Button block onClick={onClose}>
              {t('formConfig.cancelBtnText')}
            </Button>
          </div>
          <div className={classNames(styles.footerItem, styles.okBtn)}>
            <Button disabled={submitDisabled} block type="primary" onClick={onSubmit}>
              {t('formConfig.submitBtnText')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
